export default {
    total: 'พนักงานทั้งหมด',
    present: 'เข้างานตรงเวลา',
    late: 'มาสาย',
    absent: 'ขาด',
    onsite: 'ทำงานนอกสถานที่',
    leave: 'ลา'
}
